import { useMutation } from '@tanstack/react-query';

import type {
  DeleteStaffWorkScheduleOverrideResponse,
  SetStaffWorkScheduleOverrideRangeData,
  SetStaffWorkScheduleOverrideRangeResponse,
  SetStaffWorkScheduleRangeData,
  SetStaffWorkScheduleRangeResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useSetStaffWorkScheduleRangeMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      staffId: number;
      data: SetStaffWorkScheduleRangeData;
    }) =>
      HttpClient.request<SetStaffWorkScheduleRangeResponse>({
        method: 'PUT',
        url: `${params.url}/set_range`,
        params: { staff_id: params.staffId },
        data: { work_schedule: params.data },
      }),
  });

export const useSetStaffWorkScheduleOverrideRangeMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      staffId: number;
      data: SetStaffWorkScheduleOverrideRangeData;
    }) =>
      HttpClient.request<SetStaffWorkScheduleOverrideRangeResponse>({
        method: 'PUT',
        url: `${params.url}/set_range`,
        params: { staff_id: params.staffId },
        data: { work_schedule_override: params.data },
      }),
  });

export const useDeleteStaffWorkScheduleOverrideMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      staffId: number;
      locationId: number;
      date: string;
    }) =>
      HttpClient.request<DeleteStaffWorkScheduleOverrideResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.date}`,
        params: { staff_id: params.staffId, location_id: params.locationId },
      }),
  });
